module.exports = __webpack_public_path__ + "static/media/red-ribbon.df52bfd2.svg";